import { render, staticRenderFns } from "./ManageTariffs.vue?vue&type=template&id=edacf726"
import script from "./ManageTariffs.vue?vue&type=script&lang=js"
export * from "./ManageTariffs.vue?vue&type=script&lang=js"
import style0 from "./ManageTariffs.vue?vue&type=style&index=0&id=edacf726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports